export enum ELocalForageKeys {
  BOOKINGS_TABLE_PAGE_SIZE = 'bookingsTablePageSize',
  CHECKLISTS_TABLE_PAGE_SIZE = 'checklistsTablePageSize',
  DYNAMIC_BOOKING_MENUS = 'dynamicBookingMenus',
  FACILITIES_TABLE_PAGE_SIZE = 'facilitiesTablePageSize',
  FIELDS_TABLE_PAGE_SIZE = 'fieldsTablePageSize',
  INTERACTIVE_REPORT_DETAILS = 'interactiveReportDetails',
  /** Cumulative authenticated interactive report v2.1 page views per user (SP-37531). */
  INTERACTIVE_REPORT_V21_VIEW_COUNT = 'interactiveReportV21ViewCount',
  LOCALE_LANGUAGE = 'localeLanguage',
  /** Last email typed on login “sign in with email code” (pre-auth; device-local). */
  LOGIN_EMAIL_SIGN_IN_LAST_EMAIL = 'loginEmailSignInLastEmail',
  PAYMENTS_TABLE_PAGE_SIZE = 'paymentsTablePageSize',
  PRODUCE_REMARKS_COLLAPSED = 'produceRemarksCollapsed',
  PRODUCE_SIDE_PANEL_COLLAPSED = 'produceSidePanelCollapsed',
  PRODUCE_THERMOGRAPHS_COLLAPSED = 'produceThermographsCollapsed',
  PRODUCERS_TABLE_PAGE_SIZE = 'producersTablePageSize',
  REPORTS_TABLE_FILTER = 'reportsTableFilter',
  REPORTS_TABLE_PAGE_SIZE = 'reportsTablePageSize',
  SELECTED_BUSINESS_SOLUTION = 'selectedBusinessSolution',
  SHIPPERS_TABLE_PAGE_SIZE = 'shippersTablePageSize',
  SUPPLIERS_TABLE_PAGE_SIZE = 'suppliersTablePageSize',
}
